import { useEffect } from 'react';

/*
 * Hook to scroll the page back to the top when the component mounts
 */
export function useScrollToTopOnMount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
}
